import { render, staticRenderFns } from "./planned_drivers_weekly_util_tbn.vue?vue&type=template&id=1228889c&"
import script from "./planned_drivers_weekly_util_tbn.vue?vue&type=script&lang=js&"
export * from "./planned_drivers_weekly_util_tbn.vue?vue&type=script&lang=js&"
import style0 from "./planned_drivers_weekly_util_tbn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports